export default "__VITE_PUBLIC_ASSET__016d8947__"